import { LocalizedText } from "../../components/LocalizedText";
import Panel from '../../components/Panel/Panel';
import JPanel from '../../components/UI/JPanel';
import { JTabbedPane } from '../../components/UI/JTabbedPane';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { setSetting } from '../../slices/settingsSlice';
import { mute, setVolume } from '../../util/MusicPlayer';
import { PatchNotes } from './PatchNotes';
import { useTranslation } from 'react-i18next';

enum Tabs {
  SETTINGS = 'Settings',
  PATCH_NOTES = 'Patch Notes',
}

const tabs = [{ name: Tabs.SETTINGS }, { name: Tabs.PATCH_NOTES }];

export function Settings({ onClose }: { onClose: () => void }) {
  const dispatch = useAppDispatch();

  function _onClose() {
    localStorage.removeItem('settings-tab-open-patch-notes');
    dispatch(setSetting({ firstSet: true }));
    onClose();
  }

  let active = localStorage.getItem('settings-tab-open-patch-notes') !== null ? Tabs.PATCH_NOTES : Tabs.SETTINGS;

  return (
    <Panel name="Settings" onClose={_onClose}>
      <JPanel size={{ width: 400, height: 325 }}>
        <JTabbedPane size={{ width: 400, height: 300 }} tabs={tabs} active={active}>
          <JTabbedPane.Tab name={Tabs.SETTINGS}>
            <SettingsTab />
          </JTabbedPane.Tab>

          <JTabbedPane.Tab name={Tabs.PATCH_NOTES}>
            <PatchNotes />
          </JTabbedPane.Tab>
        </JTabbedPane>
      </JPanel>
    </Panel>
  );
}

export function SettingsTab() {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const settings = useAppSelector((state) => state.settings);

  const update = (partial: { [key: string]: any }) => dispatch(setSetting(partial));

  function _setVolume(e: React.ChangeEvent<HTMLInputElement>) {
    const volume = Math.min(Math.max(Number(e.target.value), 0), 100);

    dispatch(setSetting({ volume }));
    setVolume(volume);
  }

  return (
    <JPanel size={{ width: 400, height: 300 }} background="UIResource.Common.BigBG1">
      <div style={{ padding: 5 }}>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="game-language">{t('Language')}: </label>
          <select id="game-language" value={(i18n.resolvedLanguage || i18n.language || 'en').split('-')[0]}
            onChange={(event) => { void i18n.changeLanguage(event.target.value); }}
            style={{ minWidth: 155, fontFamily: 'Tahoma, Arial, sans-serif' }}>
            <option value="en">{t("English")}</option>
            <option value="th">ไทย</option>
            <option value="vi">{t("Tiếng Việt")}</option>
          </select>
          <div style={{ fontSize: 12, marginTop: 5 }}>{t('Language is saved automatically.')}</div>
        </div>
        {t('Combat')}:
        <div>
          <label>
          <input type="checkbox" checked={settings.originalDamage} onChange={() => update({ originalDamage: !settings.originalDamage })} /><LocalizedText text={' '} />
          {t('Original Damage Numbers')}
          </label>
        </div>
        <div>
          {t('Battle Font')}{' '}<select onChange={(v) => update({ font: v.target.value })} value={settings.font} disabled={settings.originalDamage}>
            <option value={'KOMIKAK'}>{t("Komikak")}</option>
            <option value={'megadeth'}>{t("Megadeth")}</option>
            <option value={'blackbox'}>{t("Blackbox")}</option>
            <option value={'cooprblk'}>{t("Cooprblk")}</option>
            <option value={'chowfun'}>{t("Chowfun")}</option>
          </select>
        </div>
        <br /> {t('Sound')}:
        <div>
          <label>
          <input
            type="checkbox"
            checked={settings.mute}
            onChange={() => {
              update({ mute: !settings.mute });
              mute(!settings.mute);
            }}
          /><LocalizedText text={' '} />
          {t('Mute Music')}
          </label>
          <br />
          {t('Volume')} %<LocalizedText text={' '} />
          <input
            type="number"
            min={0}
            max={100}
            value={settings.volume}
            disabled={settings.mute}
            onChange={_setVolume}
            style={{ width: 40 }}
          />
          <input
            type="range"
            min={0}
            max={100}
            value={settings.volume}
            disabled={settings.mute}
            onChange={_setVolume}
            style={{ width: 100, position: 'relative', top: 3 }}
          />
        </div>
      </div>
    </JPanel>
  );
}
